import { Box } from '@mui/material';


const HorizontalScrollContainer = ({ children, sx, scrollSpeed = 2, disableDragScroll = false }) => {
    const handleMouseDown = (e) => {
        if (!disableDragScroll) {
            const target = e.target;
            if (target.closest('[data-rfd-drag-handle-draggable-id]')) {
                return;
            }

            const el = e.currentTarget;
            const startX = e.pageX - el.offsetLeft;
            const scrollLeft = el.scrollLeft;
            let hasScrolled = false;

            const handleMouseMove = (e) => {
                hasScrolled = true;
                const x = e.pageX - el.offsetLeft;
                const walk = (x - startX) * scrollSpeed;
                el.scrollLeft = scrollLeft - walk;
            };

            const handleMouseUp = () => {
                document.removeEventListener('mousemove', handleMouseMove);
                document.removeEventListener('mouseup', handleMouseUp);

                if (hasScrolled) {
                    setTimeout(() => {
                        el.style.pointerEvents = 'none';
                        setTimeout(() => {
                            el.style.pointerEvents = 'auto';
                        }, 0);
                    }, 0);
                }
            };

            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);
        }
    };

    return (
        <Box
            sx={{
                overflowX: 'auto',
                overflowY: 'hidden',
                cursor: disableDragScroll ? 'default' : 'grab',
                userSelect: 'none',
                WebkitUserSelect: 'none',
                MozUserSelect: 'none',
                msUserSelect: 'none',
                '&:active': {
                    cursor: disableDragScroll ? 'default' : 'grabbing',
                },
                '&::-webkit-scrollbar': {
                    height: 8,
                },
                '&::-webkit-scrollbar-track': {
                    backgroundColor: 'rgba(0,0,0,0.05)',
                    borderRadius: 4,
                },
                '&::-webkit-scrollbar-thumb': {
                    backgroundColor: 'rgba(0,0,0,0.2)',
                    borderRadius: 4,
                    '&:hover': {
                        backgroundColor: 'rgba(0,0,0,0.3)',
                    },
                },
                ...sx,
            }}
            onMouseDown={disableDragScroll ? undefined : handleMouseDown}
        >
            {children}
        </Box>
    );
};

export default HorizontalScrollContainer;